import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { record_type, option_type, string_type, int32_type, list_type, lambda_type, unit_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { SearchResultV2$reflection, SearchResult$reflection } from "../../CommonTypes.js";
import { InvoiceeState, InvoiceeStateModule_toTranslation, InvoiceeStateModule_ofString, IsoCountryCode$reflection } from "../../DomainTypes.js";
import { skip, truncate, choose, length, ofArray, map, empty, cons, head as head_1, tail as tail_1, isEmpty, reverse } from "../../fable_modules/fable-library.3.7.20/List.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector } from "../../Redux/Store.js";
import { LoadState$2$reflection, getTranslationFrom } from "../../Global.js";
import * as react from "react";
import { renderCustomTable, renderHeader } from "../../Components/Table/Table.js";
import { maskSSN, loge } from "../../Utils.js";
import { join, isNullOrWhiteSpace, printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { uncurry, int32ToString, stringHash, comparePrimitives, min } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { RouterModule_encodeParts } from "../../fable_modules/Feliz.Router.3.8.0/Router.fs.js";
import { toString } from "../../fable_modules/fable-library.3.7.20/Long.js";
import { List_distinct } from "../../fable_modules/fable-library.3.7.20/Seq2.js";
import { regexEscape } from "../../../src/Utilities/regexReplacements.js";
import { create, match } from "../../fable_modules/fable-library.3.7.20/RegExp.js";
import { defaultArg, map as map_1 } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { dotsLoading, getMaterialIcon, Color, getStatusBall } from "../../ViewUtils.js";
import { warning, error } from "../../Components/Message/Message.js";
import { Filter_toTranslation_11D407F6, Filter$reflection } from "./Model.js";
import { singleton, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import "../../../src/Containers/Search/View.scss";


class SearchResultProps extends Record {
    constructor(LoadMoreFn, SearchResults, TotalCount, CountryCode, ResultSearchStringOpt) {
        super();
        this.LoadMoreFn = LoadMoreFn;
        this.SearchResults = SearchResults;
        this.TotalCount = (TotalCount | 0);
        this.CountryCode = CountryCode;
        this.ResultSearchStringOpt = ResultSearchStringOpt;
    }
}

function SearchResultProps$reflection() {
    return record_type("Containers.Search.View.SearchResultProps", [], SearchResultProps, () => [["LoadMoreFn", lambda_type(unit_type, unit_type)], ["SearchResults", list_type(SearchResult$reflection())], ["TotalCount", int32_type], ["CountryCode", IsoCountryCode$reflection()], ["ResultSearchStringOpt", option_type(string_type)]]);
}

export function List_tryTake(n, list) {
    const aux = (count_mut, current_mut, acc_mut) => {
        aux:
        while (true) {
            const count = count_mut, current = current_mut, acc = acc_mut;
            const matchValue = [count, current];
            if (matchValue[0] === 0) {
                return reverse(acc);
            }
            else if (!isEmpty(matchValue[1])) {
                count_mut = (matchValue[0] - 1);
                current_mut = tail_1(matchValue[1]);
                acc_mut = cons(head_1(matchValue[1]), acc);
                continue aux;
            }
            else {
                return void 0;
            }
            break;
        }
    };
    if (n < 0) {
        return void 0;
    }
    else if (n === 0) {
        return empty();
    }
    else {
        return aux(n, list, empty());
    }
}

export function List_$007CAtLeast$007C_$007C(n, list) {
    return List_tryTake(n, list);
}

const renderSearchResults = FunctionComponent_Of_Z5A158BBF((props) => {
    let resultSearchStringOpt, children_35, arg_6, arg_5;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const currentPageState = react.useState(0);
    const errorMessageState = react.useState(void 0);
    const headers = map(renderHeader, ofArray([getTranslation("CustomerContract.SearchResult.Name"), getTranslation("CustomerContract.SearchResult.PhoneNr"), getTranslation("CustomerContract.SearchResult.OrgNr"), getTranslation("Common.InvoiceeNr"), getTranslation("CustomerContract.SearchResult.ContractNr"), getTranslation("CustomerContract.SearchResult.Email")]));
    let searchResultsHtml;
    if (isEmpty(props.SearchResults)) {
        const children_45 = [getTranslation("CustomerContract.SearchNoResult")];
        searchResultsHtml = react.createElement("div", {
            className: "search-table search-table--empty",
            ["data-translation"]: "CustomerContract.SearchNoResult",
        }, ...children_45);
    }
    else {
        const nrOfRows = length(props.SearchResults) | 0;
        const pageSize = 10;
        const maxPage = (~(~(nrOfRows / pageSize))) | 0;
        const currentSkip = (pageSize * (currentPageState[0])) | 0;
        if ((currentSkip < 0) ? true : (currentSkip > nrOfRows)) {
            loge(toText(printf("[renderPaginatedTable] currentSkip: %i, nrOfRows: %i"))(currentSkip)(nrOfRows));
        }
        const currentTake = min(comparePrimitives, pageSize, nrOfRows - currentSkip) | 0;
        const currentRows = map((resultSearchStringOpt = props.ResultSearchStringOpt, (result) => {
            let activePatternResult, firstThree, arg, currentState, children_16, children_14, children_12, children_10, children_18, children_20, children_22, children_24, children_26;
            const navigateLink = RouterModule_encodeParts(ofArray(["CustomerContract", "Invoicee", toString(result.InvoiceeNr), "Subscriptions"]), 1);
            let searchString;
            if (resultSearchStringOpt != null) {
                const s = resultSearchStringOpt;
                searchString = s.toLocaleLowerCase();
            }
            else {
                searchString = "";
            }
            let patternInput;
            const allNumbers = List_distinct(choose((n) => {
                if (isNullOrWhiteSpace(n.Number)) {
                    return void 0;
                }
                else {
                    return n.Number;
                }
            }, result.Numbers), {
                Equals: (x, y) => (x === y),
                GetHashCode: stringHash,
            });
            const numbers = join(", ", allNumbers);
            patternInput = [(activePatternResult = List_$007CAtLeast$007C_$007C(3, allNumbers), (activePatternResult != null) ? ((firstThree = activePatternResult, (arg = join(", ", firstThree), toText(printf("%s, ..."))(arg)))) : numbers), numbers];
            const contractNumbers = join(", ", List_distinct(map((numbers_1) => int32ToString(numbers_1.ContractNr), result.Numbers), {
                Equals: (x_4, y_1) => (x_4 === y_1),
                GetHashCode: stringHash,
            }));
            let regexPattern;
            const arg_1 = regexEscape(searchString);
            regexPattern = toText(printf("(.*)(%s)(.*)"))(arg_1);
            const renderHighlight = (text) => {
                let children, children_2, children_4;
                if (isNullOrWhiteSpace(text)) {
                    return "-";
                }
                else {
                    try {
                        const regexMatch = match(create(regexPattern, 1), text);
                        if ((regexMatch != null) && (regexMatch.length === 4)) {
                            const children_6 = [(children = [regexMatch[1] || ""], react.createElement("span", {}, ...children)), (children_2 = [regexMatch[2] || ""], react.createElement("span", {
                                className: "search__table-cell--highlight",
                            }, ...children_2)), (children_4 = [regexMatch[3] || ""], react.createElement("span", {}, ...children_4))];
                            return react.createElement("span", {}, ...children_6);
                        }
                        else {
                            return text;
                        }
                    }
                    catch (exn) {
                        errorMessageState[1](getTranslation("CustomerContract.SearchResult.MalformedSearchQuery"));
                        return text;
                    }
                }
            };
            const orgNr = maskSSN(result.OrganizationNr, props.CountryCode);
            const invoiceeStateOpt = map_1(InvoiceeStateModule_ofString, result.CurrentState);
            const statusBallHtml = getStatusBall((invoiceeStateOpt != null) ? ((currentState = invoiceeStateOpt, (currentState.tag === 1) ? (new Color(0)) : ((currentState.tag === 2) ? (new Color(2)) : ((currentState.tag === 5) ? (new Color(2)) : ((currentState.tag === 4) ? (new Color(2)) : ((currentState.tag === 3) ? (new Color(1)) : (new Color(0)))))))) : (new Color(2)), defaultArg(map_1((_arg_2) => InvoiceeStateModule_toTranslation(getTranslation, _arg_2), invoiceeStateOpt), InvoiceeStateModule_toTranslation(getTranslation, new InvoiceeState(5))));
            const children_28 = [(children_16 = [(children_14 = [react.createElement("div", {
                className: "d-flex",
            }, statusBallHtml), (children_12 = [(children_10 = [renderHighlight(result.Name)], react.createElement("a", {
                className: "search__table-link ml-2",
                ["data-regression"]: "search-invoicee-link",
                href: navigateLink,
            }, ...children_10))], react.createElement("div", {
                className: "d-flex",
            }, ...children_12))], react.createElement("div", {
                className: "d-flex align-items-center",
            }, ...children_14))], react.createElement("td", {
                className: "search__table-cell",
            }, ...children_16)), (children_18 = [renderHighlight(patternInput[0])], react.createElement("td", {
                className: "search__table-cell",
                title: patternInput[1],
            }, ...children_18)), (children_20 = [renderHighlight(orgNr)], react.createElement("td", {
                className: "search__table-cell search__table-cell--medium-width",
            }, ...children_20)), (children_22 = [renderHighlight(toString(result.InvoiceeNr))], react.createElement("td", {
                className: "search__table-cell search__table-cell--small-width",
            }, ...children_22)), (children_24 = [renderHighlight(contractNumbers)], react.createElement("td", {
                className: "search__table-cell search__table-cell--medium-width",
            }, ...children_24)), (children_26 = [renderHighlight(result.Email)], react.createElement("td", {
                className: "search__table-cell",
            }, ...children_26))];
            return react.createElement("tr", {}, ...children_28);
        }), truncate(currentTake, skip(currentSkip, props.SearchResults)));
        let genericPaginationContainerHtml;
        const matchValue = nrOfRows > pageSize;
        if (matchValue) {
            let paginationInfoHtml;
            const children_37 = [(children_35 = [(arg_6 = ((currentSkip + currentTake) | 0), (arg_5 = ((currentSkip + 1) | 0), toText(printf("%i-%i / %i"))(arg_5)(arg_6)(props.TotalCount)))], react.createElement("span", {}, ...children_35))];
            paginationInfoHtml = react.createElement("div", {}, ...children_37);
            let buttonsHtml;
            let backButton;
            const isDisabled = (currentPageState[0]) === 0;
            const children_30 = [getMaterialIcon("chevron_left")];
            backButton = react.createElement("button", {
                disabled: isDisabled,
                type: "button",
                className: "btn btn-outline-secondary generic-pagination-button",
                onClick: (_arg_3) => {
                    currentPageState[1]((m) => (m - 1));
                },
            }, ...children_30);
            let forwardButton;
            const isDisabled_1 = nrOfRows <= (currentSkip + currentTake);
            const children_32 = [getMaterialIcon("chevron_right")];
            forwardButton = react.createElement("button", {
                disabled: isDisabled_1,
                type: "button",
                className: "btn btn-outline-secondary generic-pagination-button",
                onClick: (_arg_4) => {
                    if (((currentPageState[0]) + 2) >= maxPage) {
                        props.LoadMoreFn();
                    }
                    currentPageState[1]((m_1) => (m_1 + 1));
                },
            }, ...children_32);
            buttonsHtml = react.createElement("div", {
                className: "generic-pagination__buttons-container",
            }, backButton, forwardButton);
            genericPaginationContainerHtml = react.createElement("div", {
                className: "generic-pagination__container",
            }, paginationInfoHtml, buttonsHtml);
        }
        else {
            genericPaginationContainerHtml = react.createElement(react.Fragment, {});
        }
        const searchResultTableHtml = renderCustomTable(headers, currentRows);
        searchResultsHtml = ((nrOfRows === 0) ? searchResultTableHtml : react.createElement("div", {
            className: "generic-pagination",
        }, searchResultTableHtml, genericPaginationContainerHtml));
    }
    let errorMessageHtml;
    const matchValue_1 = errorMessageState[0];
    if (matchValue_1 != null) {
        const errorMessage = matchValue_1;
        errorMessageHtml = error(errorMessage.split(""));
    }
    else {
        errorMessageHtml = react.createElement(react.Fragment, {});
    }
    return react.createElement("div", {
        className: "search__table",
        ["data-regression"]: "search-table-container",
    }, searchResultsHtml, errorMessageHtml);
}, "search-result", uncurry(2, void 0), void 0, "renderSearchResults", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Search\\View.fs", 253);

export class SearchProps extends Record {
    constructor(SearchResults, CurrentFilters, LoadMoreFn, CountryCode, ResultSearchStringOpt) {
        super();
        this.SearchResults = SearchResults;
        this.CurrentFilters = CurrentFilters;
        this.LoadMoreFn = LoadMoreFn;
        this.CountryCode = CountryCode;
        this.ResultSearchStringOpt = ResultSearchStringOpt;
    }
}

export function SearchProps$reflection() {
    return record_type("Containers.Search.View.SearchProps", [], SearchProps, () => [["SearchResults", LoadState$2$reflection(SearchResultV2$reflection(), string_type)], ["CurrentFilters", list_type(Filter$reflection())], ["LoadMoreFn", lambda_type(unit_type, unit_type)], ["CountryCode", IsoCountryCode$reflection()], ["ResultSearchStringOpt", option_type(string_type)]]);
}

export const renderSearch = FunctionComponent_Of_Z5A158BBF((props) => {
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const children_17 = toList(delay(() => {
        let children_1, children_5, children_15, children_13;
        const matchValue = props.SearchResults;
        switch (matchValue.tag) {
            case 3: {
                return singleton((children_1 = [warning(matchValue.fields[0].split(""))], react.createElement("div", {}, ...children_1)));
            }
            case 1: {
                return singleton(dotsLoading);
            }
            case 2: {
                const searchResultV2 = matchValue.fields[0];
                if (isEmpty(searchResultV2.SearchResult)) {
                    const currentFilters = props.CurrentFilters;
                    const nrOfFilters = length(currentFilters) | 0;
                    let filterInfoHtml;
                    if (nrOfFilters > 0) {
                        let activeFiltersStr;
                        const arg_2 = getTranslation("CustomerContract.Search.ActiveFilters");
                        const arg = getTranslation("CustomerContract.Search.ThereAre");
                        activeFiltersStr = toText(printf("%s %i %s:"))(arg)(nrOfFilters)(arg_2);
                        const activeFiltersList = map((filter) => {
                            const children_3 = [Filter_toTranslation_11D407F6(getTranslation)(filter)];
                            return react.createElement("li", {}, ...children_3);
                        }, currentFilters);
                        const children_11 = [(children_5 = [getTranslation("CustomerContract.Search.AdjustFilters") + "."], react.createElement("div", {
                            ["data-translation"]: "CustomerContract.Search.AdjustFilters",
                        }, ...children_5)), react.createElement("div", {}, activeFiltersStr), react.createElement("ul", {}, ...activeFiltersList)];
                        filterInfoHtml = react.createElement(react.Fragment, {}, ...children_11);
                    }
                    else {
                        filterInfoHtml = react.createElement(react.Fragment, {});
                    }
                    return singleton((children_15 = [(children_13 = [getTranslation("CustomerContract.SearchNoResult") + "."], react.createElement("p", {
                        ["data-translation"]: "CustomerContract.SearchNoResult",
                    }, ...children_13)), filterInfoHtml], react.createElement("div", {
                        className: "search__table search__table--empty",
                    }, ...children_15)));
                }
                else {
                    return singleton(renderSearchResults(new SearchResultProps(props.LoadMoreFn, searchResultV2.SearchResult, searchResultV2.TotalCount, props.CountryCode, props.ResultSearchStringOpt)));
                }
            }
            default: {
                return singleton(react.createElement(react.Fragment, {}));
            }
        }
    }));
    return react.createElement("div", {
        className: "search",
    }, ...children_17);
}, "search", uncurry(2, void 0), void 0, "renderSearch", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Search\\View.fs", 318);

